import React from "react";
import styles from "../DetailsTab.module.css";

/**
 * RpmCcmToggle — page-level context selector for the redesigned Details tab.
 *
 * Sits at the top-left of the inner white shell, above the patient card,
 * and drives `chatBotType` ("RPM" or "CCM"). Switching scope swaps:
 *   - Chart panel content (RPM redesign vs existing CCM/careplan view)
 *   - Right-rail Monitoring panel title + content
 *   - TOCA AI tab Copilot context (RPM Copilot vs CCM Copilot)
 *
 * Visual reference: Figma "RPM TOCA AI Patient Dashboard" — folder-tab
 * style where the active tab visually connects to the card below it.
 */
const RpmCcmToggle = ({ value, onChange, showCcm = true, showRpm = true }) => {
  const handleClick = (next) => () => {
    if (next === value) return;
    // The header TimeTracker reads `selectedTab` from sessionStorage on
    // every render, and the legacy <Charts /> internal toggle uses the
    // same key. Writing it here keeps both in sync with this page-level
    // toggle. The `chatBotType` state then drives every other panel.
    try {
      sessionStorage.setItem("tab-selected", next);
    } catch (_) {
      /* sessionStorage may be unavailable in private browsing — ignore */
    }
    if (typeof onChange === "function") onChange(next);
  };

  return (
    <div className={styles.programToggle} role="tablist" aria-label="Program scope">
      {showRpm && (
        <button
          type="button"
          role="tab"
          aria-selected={value === "RPM"}
          className={`${styles.programToggleBtn} ${
            value === "RPM" ? styles.active : ""
          }`}
          onClick={handleClick("RPM")}
        >
          RPM
        </button>
      )}
      {showCcm && (
        <button
          type="button"
          role="tab"
          aria-selected={value === "CCM"}
          className={`${styles.programToggleBtn} ${
            value === "CCM" ? styles.active : ""
          }`}
          onClick={handleClick("CCM")}
        >
          CCM
        </button>
      )}
    </div>
  );
};

export default RpmCcmToggle;
